import { useState } from 'react';
import { ref, deleteObject } from 'firebase/storage';
import { storage } from '../firebase';

const DeleteControl = ({ itemType, itemName, itemPath, onDeleteSuccess }) => {
  const [deleting, setDeleting] = useState(false);

  const getYearMonthFromPath = (path) => {
    const match = path.match(/\/(\d{4}-\d{2})\//);
    return match ? match[1] : null;
  };

  const handleDelete = async () => {
    const confirmed = window.confirm(`本当に "${itemName}" (${itemType}) を削除しますか？`);
    if (!confirmed) return;

    setDeleting(true);
    try {
      const itemRef = ref(storage, itemPath);
      await deleteObject(itemRef);

      if (itemType === '動画') {
        const baseName = itemName.replace(/\.\w+$/, '');
        const folder = getYearMonthFromPath(itemPath) || 'unknown';
        const thumbRef = ref(storage, `thumbnails/${folder}/${baseName}.png`);

        try {
          await deleteObject(thumbRef);
        } catch (err) {
          // サムネイルが無くても続行
          if (err.code !== 'storage/object-not-found') throw err;
        }
      }

      onDeleteSuccess?.();
    } catch (err) {
      onDeleteSuccess?.(err); // エラー通知は親で処理
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <button
        style={deleting ? { ...styles.button, ...styles.deleting } : styles.button}
        onClick={handleDelete}
        disabled={deleting}
      >
        {deleting ? (
          <div style={styles.spinnerWrapper}>
            <span style={styles.spinner}></span> 削除中…
          </div>
        ) : (
          '🗑️ 削除'
        )}
      </button>
    </div>
  );
};

const styles = {
  wrapper: {
    marginTop: '10px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    padding: '8px 16px',
    background: 'linear-gradient(135deg, #ff8a80, #e91e63)',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 'bold',
    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
    transition: 'all 0.3s ease',
  },
  deleting: {
    background: '#bbb',
    cursor: 'not-allowed',
    boxShadow: 'none',
  },
  spinnerWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '14px',
  },
  spinner: {
    width: '16px',
    height: '16px',
    border: '2px solid white',
    borderTop: '2px solid transparent',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
};

export default DeleteControl;
